module.exports = __webpack_public_path__ + "img/Hunter-orc-f-70.b0d0df88.gif";